module.exports = __webpack_public_path__ + "static/media/Teams2.23269f5d.png";